import * as React from 'react';
import clsx from 'clsx';
import {Typography} from 'onboarding-components';

import {SvgIconReact} from 'common/components/svg-icon';

import styles from './index.module.styl';

/* eslint-disable react/destructuring-assignment */
export const HelpText = ({showProperties, children, animationTrigger}) => {
  const {bounceInput} = animationTrigger;
  return (
    <div className={clsx(styles.helpTextContainer, {[styles.bounce]: bounceInput})}>
      <div className={clsx(styles.helpText, {[styles.show]: showProperties})}>
        <SvgIconReact icon='note' />
        <Typography variant='bodySm' className={styles.propertiesHelpText}>
          You can <span className={styles.bold}> edit </span> these properties to suit your needs
        </Typography>
      </div>
      <div className={clsx(styles.helpText, {[styles.show]: !showProperties})}>
        {children}
        <Typography variant='bodySm'>
          Select an <span className={styles.bold}> event </span>to view its properties
        </Typography>
      </div>
    </div>
  );
};
